module.exports = __webpack_public_path__ + "img/default.ca964f05.png";